import { EmployeeMissionComponent } from './employee-mission/employee-mission.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AbsenceRuleHeaderSystemComponent } from './absence-rule-header-system/absence-rule-header-system.component';
import { AddEditAbsenceRuleHeaderSystemComponent } from './absence-rule-header-system/add-edit-absence-rule-header-system/add-edit-absence-rule-header-system.component';
import { AllowanceComponent } from './allowance/allowance.component';
import { AttendingLeavingComponent } from './attending-leaving/attending-leaving.component';
import { BreakDurationComponent } from './break-duration/break-duration.component';
import { DeductionComponent } from './deduction/deduction.component';
import { AddEditDelayRuleHeaderSystemComponent } from './delay-rule-header-system/add-edit-delay-rule-header-system/add-edit-delay-rule-header-system.component';
import { DelayRuleHeaderSystemComponent } from './delay-rule-header-system/delay-rule-header-system.component';
import { DurationWorkSystemComponent } from './duration-work-system/duration-work-system.component';
import { EmployeeDurationDataComponent } from './employee-duration-data/employee-duration-data.component';
import { EmployeeDurationComponent } from './employee-duration-data/employee-duration/employee-duration.component';
import { EmployeeSystemsDataComponent } from './employee-systems/employee-systems-data/employee-systems-data.component';
import { EmployeeSystemsComponent } from './employee-systems/employee-systems.component';
import { AddEditExtraTimeRuleHeaderSystemComponent } from './extra-time-rule-header-system/add-edit-extra-time-rule-header-system/add-edit-extra-time-rule-header-system.component';
import { ExtraTimeRuleHeaderSystemComponent } from './extra-time-rule-header-system/extra-time-rule-header-system.component';
import { AddEditHolidayHeaderSystemComponent } from './holiday-header-system/add-edit-holiday-header-system/add-edit-holiday-header-system.component';
import { HolidayHeaderSystemComponent } from './holiday-header-system/holiday-header-system.component';
import { HolidayComponent } from './holiday/holiday.component';
import { AddEditPermissionHeaderWorkSystemComponent } from './permission-header-work-system/add-edit-permission-header-work-system/add-edit-permission-header-work-system.component';
import { PermissionHeaderWorkSystemComponent } from './permission-header-work-system/permission-header-work-system.component';
import { PremissionComponent } from './premission/premission.component';
import { PublicHolidayComponent } from './public-holiday/public-holiday.component';
import { ExtraDetailComponent } from './worksystemSetting/extra-time-rules/extra-detail/extra-detail.component';
import { ExtraTimeRulesComponent } from './worksystemSetting/extra-time-rules/extra-time-rules.component';
import { PenalitesComponent } from './worksystemSetting/penalites/penalites.component';
import { RewardsComponent } from './worksystemSetting/rewards/rewards.component';
import { HomeComponent } from '../home/home.component';
import { AbsenceRuleComponent } from './worksystemSetting/deduction-rules/absence-rule/absence-rule.component';
import { DelayRuleComponent } from './worksystemSetting/deduction-rules/delay-rule/delay-rule.component';
import { JobTitleStructureComponent } from './ProfileSetting/job-title-structure/job-title-structure.component';
import { AddEditJobTitleStructureComponent } from './ProfileSetting/job-title-structure/add-edit-job-title-structure/add-edit-job-title-structure.component';
import { CustodyTypeComponent } from './custody/custody-type/custody-type.component';
import { EmployeeAttachmentTypeComponent } from './employee-attachment-type/employee-attachment-type.component';
import { EmployeeAttachmentComponent } from './employee-attachment/employee-attachment.component';
import { AddAttachmentComponent } from './employee-attachment/add-attachment/add-attachment.component';
import { ChangeEmployeeStatusComponent } from 'src/app/pages/hr/change-employee-status/change-employee-status.component';
import { ChangeStatusComponent } from './change-employee-status/change-status/change-status.component';
import { ImportAttendingLeavingComponent } from './import-attending-leaving/import-attending-leaving.component';
import { EmployeeInformationComponent } from './employee-information/employee-information.component';
import { EmployeeResignationComponent } from './employee-resignation/employee-resignation.component';
import { ApproveEmployeeResignationComponent } from './approve-employee-resignation/approve-employee-resignation.component';
import { GeneralCalcSalaryInputsComponent } from './general-calc-salary-inputs/general-calc-salary-inputs.component';
import { VacationRequestComponent } from './vacation-request/vacation-request.component';
import { ApprovelVacationRequestComponent } from './approvel-vacation-request/approvel-vacation-request.component';
import { EmployeeExtraTimesComponent } from 'src/app/Interfaces/hr/employee-extra-times/employee-extra-times.component';
import { ShowEmployeeWorkDurationsComponent } from './show-employee-work-durations/show-employee-work-durations.component';
import { AddEditEmployeeMissionComponent } from './add-edit-employee-mission/add-edit-employee-mission.component';
import { EditAttendingLeavingComponent } from './attending-leaving/edit-attending-leaving/edit-attending-leaving.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  {
    path: 'PublicSettingEmployee', loadChildren: () => import('./ProfileSetting/profile-setting.module').then(m => m.ProfileSettingModule)
  },
  { path: 'employee', loadChildren: () => import('./employee/employee.module').then(m => m.EmployeeModule) },
  { path: 'workSystem', loadChildren: () => import('./work-system/work-system.module').then(m => m.WorkSystemModule) },
  { path: 'employeesinformation', loadChildren: () => import('./employee-information/employeesinformation.module').then(m => m.EmployeesinformationModule) },
  {
    path: 'afairsesetting',
    loadChildren: () => import('./afairs-setting/afairs-setting.module').then(m => m.AfairsSettingModule)
  },

  { path: 'salary', loadChildren: () => import('./salary/salary.module').then(m => m.SalaryModule) },
  { path: 'Approval', loadChildren: () => import('./approval/approval.module').then(m => m.ApprovalModule) },
  { path: 'employeerequests', loadChildren: () => import('./employee-requests/employee-requests.module').then(m => m.EmployeeRequestsModule) },

  {
    path: 'permissiontype',
    component: PremissionComponent
  },
   {
    path: 'VacationRequest',
    component: VacationRequestComponent
  },
   {
    path: 'approvelvacationrequest',
    component: ApprovelVacationRequestComponent
  },
  {
    path: 'holidaytype',
    component: HolidayComponent
  },
  //  {
  //   path: 'GeneralInputs',
  //   component: GeneralCalcSalaryInputsComponent
  // },
  {
    path: 'allowancetype',
    component: AllowanceComponent
  },
  {
    path: 'deductiontype',
    component: DeductionComponent
  },
  {
    path: 'publicholidaytype',
    component: PublicHolidayComponent
  },
  {
    path: 'durationworksystem',
    component: DurationWorkSystemComponent
  },
  {
    path: 'showemployeeworkdurations',
    component: ShowEmployeeWorkDurationsComponent
  },
  {
    path: 'breakduration',
    component: BreakDurationComponent
  },
  {
    path: 'employeeduration',
    component: EmployeeDurationDataComponent
  },
  {
    path: 'add_edit_duration',
    component: EmployeeDurationComponent
  },
  {
    path: 'rewards',
    component: RewardsComponent
  },
  {
    path: 'penality',
    component: PenalitesComponent
  },
  {
    path: 'DelayRule',
    component: DelayRuleComponent
  },
  {
    path: 'AbsenceRule',
    component: AbsenceRuleComponent
  },
  {
    path: 'ExtraTimeRules',
    component: ExtraTimeRulesComponent
  },
  {
    path: 'add-edit-ExtraTimeRules',
    component: ExtraDetailComponent
  },
  {
    path: 'PermissionHeaderWorkSystem',
    component: PermissionHeaderWorkSystemComponent
  },
  {
    path: 'add-edit-PermissionHeaderWorkSystem',
    component: AddEditPermissionHeaderWorkSystemComponent
  },
  {
    path: 'HolidayHeaderWorkSystem',
    component: HolidayHeaderSystemComponent
  },
  {
    path: 'add-edit-holidaySystem',
    component: AddEditHolidayHeaderSystemComponent
  },
  {
    path: 'AbsenceHeaderWorkSystem',
    component: AbsenceRuleHeaderSystemComponent
  },
  {
    path: 'add-edit-AbsenceSystem',
    component: AddEditAbsenceRuleHeaderSystemComponent
  },
  {
    path: 'DelayHeaderWorkSystem',
    component: DelayRuleHeaderSystemComponent
  },
  {
    path: 'add-edit-DelaySystem',
    component: AddEditDelayRuleHeaderSystemComponent
  },
  {
    path: 'ExtraHeaderWorkSystem',
    component: ExtraTimeRuleHeaderSystemComponent
  },
  {
    path: 'EmployeeExtraTimes',
    component: EmployeeExtraTimesComponent
  },
  {
    path: 'EmployeeMission',
    component: EmployeeMissionComponent
  },
  {
    path: 'add-edit-EmployeeMission',
    component: AddEditEmployeeMissionComponent
  },
  {
    path: 'add-edit-ExtraSystem',
    component: AddEditExtraTimeRuleHeaderSystemComponent
  },
  {
    path: 'Attending_Leaving',
    component: AttendingLeavingComponent
  },
   {
    path: 'editAttendance',
    component:EditAttendingLeavingComponent
  },
  {
    path: 'EmployeeSystems',
    component: EmployeeSystemsComponent
  },
  {
    path: 'EmployeeSystemsData',
    component: EmployeeSystemsDataComponent
  },
  {
    path: 'JobTitleStructure',
    component: JobTitleStructureComponent
  },
  {
    path: 'add-edit-jobTitleStructure',
    component: AddEditJobTitleStructureComponent
  },
  {
    path: 'custodies',
    loadChildren: ()=> import('./custody/custody.module').then((m)=>m.CustodyModule)
  },
  {
    path :'EmployeeAttachmentTypes',
    component: EmployeeAttachmentTypeComponent
  },
  {
    path: 'EmployeeAttachment',
    component : EmployeeAttachmentComponent
  },
  {
    path: 'add-attachment',
    component: AddAttachmentComponent
  },
  {
    path :'ChangeEmployeeStatus',
    component:  ChangeEmployeeStatusComponent
  },
  {
    path : 'changeStatus',
    component: ChangeStatusComponent
  },
  {
    path: 'EmployeesInformation',
    component: EmployeeInformationComponent
  },
  {
    path: 'EmployeeResignation',
    component: EmployeeResignationComponent
  },
  {
    path: 'ApproveEmployeeResignation',
    component: ApproveEmployeeResignationComponent
  }


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HRRoutingModule { }
